import { render } from "./CustomerQuestion.vue?vue&type=template&id=52dd24cd"
import script from "./CustomerQuestion.vue?vue&type=script&lang=js"
export * from "./CustomerQuestion.vue?vue&type=script&lang=js"

import "./CustomerQuestion.vue?vue&type=style&index=0&id=52dd24cd&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__